












import { mixins } from 'vue-class-component'
import { Component, Prop, Watch, Emit } from 'vue-property-decorator'
import AppSelector from '@/components/AppSelector.vue'
import RecordTypesHandler from '@/mixins/record-types'
import { IAccountCertificateTypeInput } from '@/modules/AccountCertificate/interfaces/account-certificate-form'
import { typeValues } from '@/modules/AccountCertificate/helpers/account-certificate'

@Component({
  components: {
    AppSelector
  }
})
export default class AccountFormRecordType extends mixins(RecordTypesHandler) {
  @Prop({ type: Object as () => IAccountCertificateTypeInput }) value!: IAccountCertificateTypeInput

  get options () {
    return typeValues
  }

  @Watch('value.typeIdx', { deep: true })
  onTypeChanged (val: number) {
    this.onSelectionChanged(val)
  }

  @Emit('change')
  onSelectionChanged (val: number) {
    this.validate()
    return val
  }

  validate () {
    return true
  }
}
